kv.controller('sysSecurityGroupListCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
    var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
    vm.primaryKey = 'security_group_id';
    vm.entity = 'security_group';

    vm.count = {
        total: 0,
        showing: 0
    };

    vm.getInfinitScroll({
        params: {
            action: 'security_group'
        },
        url: "security_group",
    });

    return vm;
});

